import React from "react"
import { Link, graphql } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"

import Layout from "../../components/layout"
import PostContentHeader from "../../components/post-content-header"
import PostMainImage from "../../components/post-main-image"
import CategoryDateShare from "../../components/category-date-share"
import Seo from "../../components/seo"
import AuthorContent from "../../components/author-content"

import _ from 'lodash'
import ogImage from "../../images/posts/21/thumb-landscape.jpg"

const Post21 = ({ data: { allCategoryJson, postsJson }, location }) => { 
  
  const category = _.find(allCategoryJson.edges, (edge) => {
    return edge.node.categoryId === postsJson.categoryId
  }).node

return (
<Layout>
  <Seo title={postsJson.title} description={postsJson.description} ogImage={ogImage} />
  <div className="posts">
    <PostContentHeader categoryName={category.nameJA} postTitle={postsJson.title} location={location} />
    <section id="pickup-article">
      <PostMainImage post={postsJson} />
      <div className="description wrapper text-two-cloumn">
        <CategoryDateShare category={category} post={postsJson} />
        <div className="title">
          <h1>{postsJson.title}</h1>
          <p>
            エルメスはファッション業界を代表するブランドで知られていますが、
            始まりは1837年に創業した高級馬具工房でした。馬具製作で培われた高度な技術は現在も受け継がれており、品質の高さは折り紙付き。ラグジュアリーブランド好きの方の中には、エルメスに特別思い入れのある方も少なくないのでは？
          </p>
        </div>
      </div>
    </section>
    <div className="wrapper">
      <section className="bag-content">
        <div className="text-max-width">
          <h2>バーキン＆ケリー</h2>
          <p>エルメスのバッグといえば、真っ先に名前があがるのがバーキンとケリー。バーキンは女優のジェーン・バーキン、ケリーは元女優でモナコ公国の公妃 グレース・ケリーから名付けられたというエルメスを代表する定番バッグです。</p>
        </div>
        <figure>
            <StaticImage src="../../images/posts/21/1.jpg" alt="" />
        </figure>
        <p>手にすると背筋もピンっと伸びるような、気品あふれるケリー。</p>
        <figure>
            <StaticImage src="../../images/posts/21/2.jpg" alt="" />
        </figure>
        <div className="img-two-cloumn">
            <figure className="img-small">
                <StaticImage src="../../images/posts/21/3.jpg" alt="" />
                <span className="text-center">バーキン35 /34x24x18cm(幅x高さxマチ)</span>
            </figure>
            <figure className="img-small">
                <StaticImage src="../../images/posts/21/4.jpg" alt="" />
                <span className="text-center">ケリー28 /29x21x11cm(幅x高さxマチ)</span>
            </figure>
        </div>
        <div className="text-max-width">
          <p>エルメスにはバーキンやケリーの他にも魅力的なバッグがたくさんあります。<br></br>キャンバス地のバッグはとても軽く日常使いにぴったり。そして、なんだか上品なのです。<br></br>エルメスはカジュアルなバッグでも購入すると数十万円するものばかり…。そこで、みんながよく使っているエルメスの人気バッグ10点をご紹介します。ラクサスで肩肘張らずに楽しみましょう！</p>
        </div>   
        <div className="text-max-width">
          <h2>ボリード</h2>
          <p>ボリードはバーキンやケリーと同じく、長い歴史をもっています。世界で初めて誕生したファスナーバッグがこのボリードなのです。丸みを帯びたフォルムからは可愛らしさを感じます。また、収納力が高いことから、デイリーバッグ、ビジネスバッグとしてもオススメです。</p>
        </div>
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/21/5.jpg" alt="" />
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/21/6.jpg" alt="" />
          </figure>
        </div>       
        <span className="text-center">31x25x13cm(幅x高さxマチ)</span>                
        <div className="text-max-width">
          <h2>ピコタン</h2>
          <p>上品さとカジュアルさを兼ね備えたデザインが魅力です。明るめの色を選んだり、デニムと合わせたりしても、カジュアルになり過ぎないのはエルメスだからこそ！</p>
        </div>        
        <figure>
          <StaticImage src="../../images/posts/21/7.jpg" alt="" />
        </figure>
        <figure className="img-small">
            <StaticImage src="../../images/posts/21/8.jpg" alt="" />
        </figure>
        <span className="text-center">18x18x13cm(幅x高さxマチ)</span>
        <div className="text-max-width">
          <h2>カバック</h2>
          <p>エルメスオレンジが素敵！収納力抜群で、トップハンドルとショルダーの２つが備わった機能的なバッグです。通勤やマザーズバッグにも最適♪</p>
        </div>
        <div className="img-two-cloumn">
          <figure className="img-small">
              <StaticImage src="../../images/posts/21/9.jpg" alt="" />
          </figure>
          <figure className="img-small">
              <StaticImage src="../../images/posts/21/10.jpg" alt="" />
          </figure>
        </div>        
        <span className="text-center">30x25x10cm(幅x高さxマチ)</span>
        <Link to="https://laxus.co/app/pc/bags/hermes" className="view-all-button">
          エルメスのバッグを見る
        </Link>          
        <div className="text-max-width">
          <h2>エヴリン</h2>
          <p>Hのパンチングが印象的。ショルダータイプのエヴリンはエルメスのバッグの中でもカジュアルなタイプです。日常使いにもってこい！</p>
        </div>
        <figure>
          <StaticImage src="../../images/posts/21/11.jpg" alt="" />
        </figure>
        <figure className="img-small">
          <StaticImage src="../../images/posts/21/12.jpg" alt="" />
        </figure>
        <span className="text-center">30x30x8cm(幅x高さxマチ)</span>
        <div className="text-max-width">
          <h2>サンチュール</h2>
          <p>丈夫で軽いキャンバス素材が心強い！間口が大きく開き、マチもたっぷりあるので収納力抜群です。毎日でも使いたくなりそう！</p>
        </div>
        <div className="img-two-cloumn">                
          <figure className="img-small">
          <StaticImage src="../../images/posts/21/13.jpg" alt="" />
          </figure>
          <figure className="img-small">
          <StaticImage src="../../images/posts/21/14.jpg" alt="" />
          </figure>
        </div>                  
        <span className="text-center">29x24x13cm(幅x高さxマチ)</span>
        <div className="text-max-width">
          <h2>ヴァルパライソ</h2>
          <p>抜群の収納力とスタイリッシュなデザインが人気の秘密です。大きさのわりに軽くてビックリ！</p>
        </div>
        <figure className="img-small">
          <StaticImage src="../../images/posts/21/15.jpg" alt="" />
        </figure>
        <span className="text-center">41x28x18cm(幅x高さxマチ)</span>
        <figure>
          <StaticImage src="../../images/posts/21/16.jpg" alt="" />
        </figure>
        <p>フラップ付きは中身が見えない安心感が◎フラップ部分がレザーでボディとハンドルはキャンバス素材です。</p>
        <figure>
          <StaticImage src="../../images/posts/21/17.jpg" alt="" />
        </figure>
        <p>中には大きなポケットと付属のポーチがあります。荷物の仕分けに役立ちそう。</p> 
        <div className="text-max-width">
          <h2>サックコロラド</h2>
          <p>緩やかな美しい曲線がポイント♡シンプルながら他にはないデザインで、大人のカジュアルスタイルにプラスしたい1品。</p>
        </div>
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/21/18.jpg" alt="" />
          </figure>              
          <figure className="img-small">
            <StaticImage src="../../images/posts/21/19.jpg" alt="" />
          </figure>
        </div>
        <span className="text-center">26x15x6cm(幅x高さxマチ)</span>                   
        <div className="text-max-width">
          <h2>ヴァルパライソ</h2>
          <p>キャンバス素材とレザーとの組み合わせが素敵♡カジュアルになりすぎず上品にまとまります♪</p>
        </div>
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/21/20.jpg" alt="" />
          </figure>              
          <figure className="img-small">
            <StaticImage src="../../images/posts/21/21.jpg" alt="" />
          </figure>
        </div>
        <span className="text-center">30x25x11cm(幅x高さxマチ)</span>
        <div className="text-max-width">
          <h2>ガーデンパーティ</h2>
          <p>シンプルで軽く、機能性が高いのが魅力♪ファッションのスタイルを問わず、日常使いできるデザインです。</p>
        </div>
        <figure className="img-small">
          <StaticImage src="../../images/posts/21/22.jpg" alt="" />
        </figure>
        <span className="text-center">30x25x16cm(幅x高さxマチ)</span>
        <div className="text-max-width">
          <h2>ダルヴィ</h2>
          <p>丸みのあるエレガントなフォルムとワンハンドルのデザイン♡デニムスタイルも上品にまとまります。</p>
        </div>
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/21/23.jpg" alt="" />
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/21/24.jpg" alt="" />
          </figure>          
        </div>
        <span className="text-center">30x23x11cm(幅x高さxマチ)</span>    
        <div className="text-two-cloumn">
          <h2>エルメスが身近な存在に！</h2>
          <p>エルメス最大の特徴である洗練されたデザインと美しいシルエットは、今もなお世界中の女性たちを虜にしています。多くの方の憧れブランドであるエルメスも、ラクサスならばとっても身近な存在です。肩肘張らずに日常使いしてみてくださいね！</p>
        </div>                          
        <Link to="https://laxus.co/app/pc/bags/hermes" className="view-all-button">
          エルメスのバッグを見る
        </Link>                
      </section>
      <AuthorContent authorId={postsJson.authorId} />
    </div>
  </div>
</Layout>
)}

export default Post21

export const pageQuery = graphql`
  query {
    postsJson(postId: {eq: 21}) {
      id
      title
      description
      postId
      postedAt
      description
      categoryId
      authorId
      thumbnailSquare {
        src {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
      thumbnailLandscape {
        src {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
    }
    allCategoryJson(sort: {fields: sortOrder}) {
      edges {
        node {
          id
          categoryId
          slug
          nameJA
          nameEN
          description
        }
      }
    }
  }
`
